import deliveryModeType from "./deliveryModeTypes";

const initialState = {
  allDeliveryModes: {},
  filterNoPage: {},
  loading: false,
  deleting: false,
  filtering: false,
  searching: false,
  storeDeliveryMode: {},
  singleDeliveryMode: {},
  deleteCoupon: {},
  myCoupons: {},
  emptyCoupon: {},
  filterCoupons: [],
  search: [],
  reloadCoupon: false,
};
export default function deliveryModeReducer(state = initialState, action) {
  switch (action.type) {
    case deliveryModeType.GET_ALL_DELIVERY_MODE:
      return {
        ...state,
        allDeliveryModes: action.payLoad?.data,
      };
    case deliveryModeType.STORE_DELIVERY_MODE:
      return {
        ...state,
        storeDeliveryMode: action.payLoad?.data?.data,
      };
    case deliveryModeType.DELETE_PROMO:
      return {
        ...state,
        deleteCoupon: action.payLoad.data.data,
      };

    case deliveryModeType.SHOW_DELIVERY_MODE:
      return {
        ...state,
        singleDeliveryMode: action.payLoad?.data,
      };
   
    case deliveryModeType.FILTER_DELIVERY_MODE:
      return {
        ...state,
        allDeliveryModes: action.payLoad?.data,
      };
    case deliveryModeType.FILTER_PROMO_NOPAGE:
      return {
        ...state,
        filterNoPage: action.payLoad?.data,
      };
    case deliveryModeType.SEARCH_DELIVERY_MODE:
      return {
        ...state,
        search: action.payLoad?.data,
      };

    case deliveryModeType.LOADING_DELIVERY_MODE:
      return {
        ...state,
        loading: action.payLoad,
      };
    case deliveryModeType.DELETING:
      return {
        ...state,
        deleting: action.payLoad,
      };
    case deliveryModeType.FILTERING:
      return {
        ...state,
        filtering: action.payLoad,
      };
    case deliveryModeType.LOADING_SEARCH:
      return {
        ...state,
        searching: action.payLoad,
      };
    default:
      return state;
  }
}
